import { InstancedMesh, Material, Object3D, Texture, WebGLRenderTarget } from 'three';

function disposeMaterial(material: Material, textures: Set<Texture>): void {
  const disposeTexture = (texture: Texture) => { if (!textures.has(texture)) { textures.add(texture); texture.dispose(); } };
  const record = material as unknown as Record<string, unknown>;
  for (const value of Object.values(record)) {
    if (value instanceof Texture) disposeTexture(value);
    if (value instanceof WebGLRenderTarget) value.dispose();
  }
  const uniforms = record.uniforms as Record<string, { value?: unknown }> | undefined;
  if (uniforms) {
    for (const uniform of Object.values(uniforms)) {
      if (uniform.value instanceof Texture) disposeTexture(uniform.value);
    }
  }
  material.dispose();
}

export function disposeObjectTree(root: Object3D): void {
  const geometries = new Set<{ dispose(): void }>();
  const materials = new Set<Material>();
  root.traverse((object) => {
    if (object instanceof InstancedMesh) object.dispose();
    const renderable = object as Object3D & { geometry?: { dispose(): void }; material?: Material | Material[] };
    if (renderable.geometry) geometries.add(renderable.geometry);
    if (Array.isArray(renderable.material)) renderable.material.forEach((material) => materials.add(material));
    else if (renderable.material) materials.add(renderable.material);
  });
  geometries.forEach((geometry) => geometry.dispose());
  const textures = new Set<Texture>();
  materials.forEach(material => disposeMaterial(material, textures));
}
